import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'

class Header extends Component {
  constructor () {
    super()
    this.state = {
      searchText: ''
    }
    this._submitForm = this._submitForm.bind(this)
  }

  componentDidMount () {
    if (this.props.match.params.searchText) {
      this.setState({ searchText: this.props.match.params.searchText })
    }
  }

  _submitForm (event) {
    event.preventDefault()
    this.props.history.push(`/search/${this.state.searchText}`)
  }

  render () {
    return (
      <nav className='navbar navbar-expand-md navbar-dark bg-dark fixed-top'>
        <Link className='navbar-brand' to='/'>CEC Data Repository</Link>
        <button className='navbar-toggler' type='button' data-toggle='collapse' data-target='#navbarsExampleDefault' aria-controls='navbarsExampleDefault' aria-expanded='false' aria-label='Toggle navigation'>
          <span className='navbar-toggler-icon' />
        </button>

        <div className='collapse navbar-collapse' id='navbarsExampleDefault'>
          <ul className='navbar-nav mr-auto'>
            <li className='nav-item'>
              <Link className='nav-link' to='/'>Home</Link>
            </li>
            <li className='nav-item'>
              <Link className='nav-link' to='/federal-ridings'>Federal ridings</Link>
            </li>
            <li className='nav-item'>
              <Link className='nav-link' to='/provincial-ridings'>Provincial ridings</Link>
            </li>
            <li className='nav-item'>
              <Link className='nav-link' to='/power-projects'>Power projects</Link>
            </li>
            <li className='nav-item'>
              <Link className='nav-link' to='/other-projects'>Other projects</Link>
            </li>
          </ul>
        </div>
      </nav>
    )
  }
}

export default withRouter(Header)



// WEBPACK FOOTER //
// ./src/components/App/Header.js